import {
  DialogActions,
  FormControlLabel,
  TextField,
  Typography,
  IconButton,
  Divider,
} from '@material-ui/core'
import Button from '@material-ui/core/Button'
import DialogContent from '@material-ui/core/DialogContent'
import Grid from '@material-ui/core/Grid'
import withStyles from '@material-ui/core/styles/withStyles'
import ThumbDownAltOutlinedIcon from '@material-ui/icons/ThumbDownAltOutlined'
import ThumbUpAltOutlinedIcon from '@material-ui/icons/ThumbUp'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline'
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline'
import React, { useEffect, useState } from 'react'
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator'
import { useDispatch } from 'react-redux'
import { SNACKBAR } from '../../main/MainActions'
import Checkbox from '@material-ui/core/Checkbox'
import NumberFormat from '../../components/NumberFormat'
import styles from '../../../resources/theme/users'
import filterStylesComponents from '../../../assets/filterComponentsStyles'
import colors from '../../../assets/colors'

function Form(props) {
  const { data, onClose, onSubmit, notShowPost, children } = props
  const dispatch = useDispatch()

  const styles = filterStylesComponents()

  const [form, updateForm] = useState({
    id: '',
    name: '',
    description: '',
    max_users: '',
    is_active: 1,
    advantages: [],
  })

  const updateField = React.useCallback(name => e => {
    updateForm({
      ...form,
      [name]: e.target.value,
    })
  })

  const addAdvantage = () => {
    updateForm({
      ...form,
      advantages: [...(form.advantages || []), { label: '', value: '' }],
    })
  }

  const updateAdvantage = (index, field) => e => {
    const advantages = [...(form.advantages || [])]
    advantages[index] = { ...advantages[index], [field]: e.target.value }
    updateForm({ ...form, advantages })
  }

  const removeAdvantage = index => () => {
    const advantages = [...(form.advantages || [])]
    advantages.splice(index, 1)
    updateForm({ ...form, advantages })
  }

  const statusChange = () => {
    form.is_active == 1
      ? updateForm({
          ...form,
          is_active: 0,
        })
      : updateForm({
          ...form,
          is_active: 1,
        })
  }

  const handleClose = () => onClose && onClose()

  const onSubmitForm = e => {
    e.preventDefault()
    onSubmit && onSubmit(form)
  }

  const onSubmitAndRedirect = e => {
    e.preventDefault()
    onSubmit && onSubmit(form, true)
  }

  useEffect(() => {
    if (!data) return

    let advantages = data?.advantages || []
    if (typeof advantages === 'string') {
      try {
        advantages = JSON.parse(advantages) || []
      } catch (err) {
        advantages = []
      }
    }

    updateForm({
      ...form,
      ...data,
      description: data?.description || '',
      advantages: Array.isArray(advantages) ? advantages : [],
    })
  }, [data])

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} style={{ marginTop: '1em' }}>
        <ValidatorForm>
          <Grid container spacing={2}>
            <Grid item sm={6} xs={4} lg={4}>
              <TextValidator
                validators={['required']}
                errorMessages={['Campo Obrigatório']}
                onChange={updateField('name')}
                label="Nome"
                fullWidth
                value={form.name}
              />
            </Grid>

            <Grid item sm={6} xs={4} lg={4}>
              <TextField
                type="number"
                onChange={updateField('max_users')}
                label="Máximo de Usuários"
                fullWidth
                value={form.max_users}
              />
            </Grid>

            <Grid item sm={6} xs={4} lg={4}>
              <TextField
                onChange={updateField('price')}
                label="Valor"
                fullWidth
                value={form.price}
                InputProps={{
                  inputComponent: NumberFormat,
                }}
              />
            </Grid>

            <Grid item sm={6} xs={12} lg={12}>
              <TextField
                type="text"
                onChange={updateField('description')}
                label="Descrição"
                fullWidth
                value={form.description}
              />
            </Grid>
          </Grid>

          <Grid item xs={12} lg={3} sm={12} md={6}>
            <FormControlLabel
              control={
                <Checkbox
                  icon={<ThumbDownAltOutlinedIcon />}
                  checkedIcon={<ThumbUpAltOutlinedIcon color="secondary" />}
                  checked={form.is_active}
                  onChange={statusChange}
                  value={form.is_active}
                />
              }
              label="Ativo?"
            />
          </Grid>

          <Grid container spacing={2} style={{ marginTop: '0.5em' }}>
            <Grid item xs={12}>
              <Divider />
            </Grid>

            <Grid
              item
              xs={12}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <Typography
                style={{ fontSize: '15px', fontWeight: 500 }}
                color={colors.primary}
              >
                Vantagens do plano
              </Typography>

              <Button
                size="small"
                startIcon={<AddCircleOutlineIcon />}
                onClick={addAdvantage}
              >
                Adicionar vantagem
              </Button>
            </Grid>

            {(!form.advantages || form.advantages.length === 0) && (
              <Grid item xs={12}>
                <Typography
                  style={{ fontSize: '13px', color: '#9e9e9e' }}
                >
                  Nenhuma vantagem cadastrada. Clique em &quot;Adicionar
                  vantagem&quot; para incluir.
                </Typography>
              </Grid>
            )}

            {(form.advantages || []).map((advantage, index) => (
              <Grid
                container
                spacing={1}
                item
                xs={12}
                key={index}
                alignItems="center"
              >
                <Grid item xs={5} sm={5}>
                  <TextField
                    onChange={updateAdvantage(index, 'label')}
                    label="Título"
                    placeholder="Ex: Módulo"
                    fullWidth
                    value={advantage.label || ''}
                  />
                </Grid>

                <Grid item xs={6} sm={6}>
                  <TextField
                    onChange={updateAdvantage(index, 'value')}
                    label="Descrição"
                    placeholder="Ex: Lavanderia"
                    fullWidth
                    value={advantage.value || ''}
                  />
                </Grid>

                <Grid item xs={1} sm={1}>
                  <IconButton
                    size="small"
                    onClick={removeAdvantage(index)}
                    aria-label="Remover vantagem"
                  >
                    <DeleteOutlineIcon />
                  </IconButton>
                </Grid>
              </Grid>
            ))}
          </Grid>

          <>{children}</>
        </ValidatorForm>
      </Grid>

      <Grid item xs={12}>
        <Grid
          container
          alignItems="center"
          spacing={2}
          justifyContent="flex-end"
        >
          {!notShowPost && (
            <Grid item>
              <Button onClick={handleClose}>Cancelar</Button>
            </Grid>
          )}

          {notShowPost && (
            <Grid item>
              <Button
                className={styles.btnSalvar}
                type="button"
                onClick={onSubmitAndRedirect}
              >
                Salvar e agendar
              </Button>
            </Grid>
          )}

          <Grid item>
            <Button className={styles.btnSalvar} onClick={onSubmitForm}>
              Salvar
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default withStyles(styles)(Form)
